export default "__VITE_ASSET__gCzye6bi__"